/**
 * Validation utilities for user input
 */

export type ValidationConstants = {
  MIN_CHARACTERS: number;
  MAX_CHARACTERS: number;
};

export const COMMENT_VALIDATION_CONSTANTS: ValidationConstants = {
  MIN_CHARACTERS: 1,
  MAX_CHARACTERS: 500,
} as const;

export const USERNAME_VALIDATION_CONSTANTS: ValidationConstants = {
  MIN_CHARACTERS: 1,
  MAX_CHARACTERS: 15,
} as const;

/**
 * Validates comment input based on character count and content requirements
 * @param inputValue - The input string to validate
 * @param constants - Optional validation constants (defaults to COMMENT_VALIDATION_CONSTANTS)
 * @returns Empty string if valid, error message if invalid
 */
export const validateCommentInput = (
  inputValue: string,
  constants: ValidationConstants = COMMENT_VALIDATION_CONSTANTS,
): string => {
  const trimmedValue = inputValue.trim();
  const characterCount = inputValue.length;

  if (trimmedValue.length > 0 && characterCount < constants.MIN_CHARACTERS) {
    return `最低${constants.MIN_CHARACTERS}文字以上入力してください`;
  }
  if (characterCount > constants.MAX_CHARACTERS) {
    return `${constants.MAX_CHARACTERS}文字まで入力可能です`;
  }
  return "";
};

/**
 * Validates username input based on character count requirements
 * @param inputValue - The input string to validate
 * @returns Boolean indicating if the username is valid
 */
export const validateUsername = (inputValue: string): boolean => {
  const trimmedValue = inputValue.trim();
  return trimmedValue.length > 0 && trimmedValue.length <= USERNAME_VALIDATION_CONSTANTS.MAX_CHARACTERS;
};
